/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .media-container[_ngcontent-%COMP%]{min-height:120px;min-width:120px}[_nghost-%COMP%]   .loader-container[_ngcontent-%COMP%]{background:0 0}"];
export { styles as styles };
